/* eslint-disable prettier/prettier */
/* eslint-disable */

import React from 'react';

import { Doughnut } from '@reactchartjs/react-chart.js';

import './index.scss';

interface IDoughnutChartProps {
  total: number | string | null ;
  color: string;
  incomingData: number[];
  incomingLabels: string[];
  desktopHeader?: boolean;
}

const DiagramDoughnut: React.FC<IDoughnutChartProps> = ({
  total, color, incomingLabels, incomingData, desktopHeader
}) => {
  const singleData = () => ({
    labels: incomingLabels,
    datasets: [
      {
        label: '',
        data: incomingData,
        backgroundColor: [color, '#F4F3F8'],
        hoverBackgroundColor: [color, '#F4F3F8'],
        borderWidth: 0,
        weight: 0.3
      }
    ]
  });

  const options = {
    responsice: true,
    maintainAspectRatio: false,
    cutoutPercentage: 90,
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    plugins: {
      datalabels: {
        display: false,
        color: '#7B819B'
      }
    }
  };
  return (
    <div className="exam-doughnut diagnosctix-doughnut">
      <Doughnut data={singleData} options={options} type="doughnut" />
      <div className={`exam-doughnut__header ${desktopHeader ? 'exam-doughnut__header--no-mobile' : ''}`}>
        <span className="exam-doughnut__result">
          {total}
          %
        </span>
      </div>
    </div>
  );
};

export default DiagramDoughnut;
